import React, { useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import { useFormik } from 'formik'
import { palette } from 'styles/colors'
import * as Yup from 'yup'
import Input from 'components/Input'
import Button from 'components/Button'
import Checkbox from 'components/Checkbox'
import Select from 'components/Select'

const promocodeSchema = Yup.object().shape({
  code: Yup.string()
    .min(3, 'Промокод слишком короткий')
    .max(32, 'Промокод слишком длинный')
    .required('Это обязательное поле'),
  title: Yup.string(),
  discountPercent: Yup.number()
    .min(0, 'Минимум 0')
    .max(100, 'Максимум 100')
    .required('Укажите скидку'),
  appliesTo: Yup.string().required('Укажите область'),
  isActive: Yup.boolean()
})

const APPLIES_OPTIONS = [
  { value: 'demo', name: 'Демо-подписка' },
  { value: 'subscription', name: 'Абонемент' },
  { value: 'reception', name: 'Разовый приём' },
  { value: 'subscription_reception', name: 'Приём + подписка' },
  { value: 'universal', name: 'Универсальный' }
]

const Promocode = ({ classes, editedObj, handleSubmit, isLoading }) => {
  const formik = useFormik({
    initialValues: {
      code: editedObj ? editedObj.code : '',
      title: editedObj ? editedObj.title : '',
      discountPercent: editedObj ? editedObj.discountPercent ?? 0 : 0,
      appliesTo: editedObj ? editedObj.appliesTo || 'demo' : 'demo',
      isActive: editedObj ? editedObj.isActive : true
    },
    validationSchema: promocodeSchema,
    onSubmit: (...props) => handleSubmit(...props)
  })

  useEffect(() => {
    document.title = editedObj
      ? `Редактирование ${editedObj.code}`
      : 'Создание промокода'
    return () => (document.title = 'Промокоды')
  }, [])

  return (
    <form onSubmit={formik.handleSubmit} className={classes.wrapper}>
      {editedObj ? <div className={classes.line}>{editedObj.code}</div> : null}
      <div className={classes.field}>
        <Typography className={classes.title} variant="subtitle1">
          Промокод:
        </Typography>
        <Input
          formik={formik}
          fieldName={'code'}
          variant={'standard'}
          otherStyles={{ width: '100%' }}
          standard
        />
      </div>
      <div className={classes.field}>
        <Typography className={classes.title} variant="subtitle1">
          Название:
        </Typography>
        <Input
          formik={formik}
          fieldName={'title'}
          variant={'standard'}
          otherStyles={{ width: '100%' }}
          standard
        />
      </div>
      <div className={classes.field}>
        <Typography className={classes.title} variant="subtitle1">
          Скидка %:
        </Typography>
        <Input
          formik={formik}
          fieldName={'discountPercent'}
          variant={'standard'}
          type="number"
          otherStyles={{ width: '100%' }}
          standard
        />
      </div>
      <div className={classes.field}>
        <Typography className={classes.title} variant="subtitle1">
          Применяется к:
        </Typography>
        <Select
          formik={formik}
          fieldName="appliesTo"
          title="Область"
          selectValues={APPLIES_OPTIONS}
          otherStyles={{ width: '100%', minWidth: 220 }}
        />
      </div>
      {editedObj && (
        <Checkbox label="Активен" formik={formik} fieldName={'isActive'} />
      )}
      <div className={classes.buttons}>
        <Button
          text={'Сохранить'}
          otherStyles={{
            width: '220px',
            height: '40px',
            backgroundColor: palette.white,
            border: `1px solid ${palette.blue}`,
            borderRadius: '10px',
            color: palette.blue,
            marginRight: '1em',
            marginLeft: '1em'
          }}
          type={'submit'}
          loader={isLoading}
        />
      </div>
    </form>
  )
}

const styles = () => ({
  wrapper: {
    width: '600px'
  },
  line: {
    textAlign: 'center',
    marginBottom: '20px'
  },
  title: {
    fontWeight: 'bold',
    margin: '0 20px 10px 0',
    minWidth: 140
  },
  field: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: 12
  },
  buttons: {
    textAlign: 'center'
  },
  '@global': {
    '.MuiDialog-paperWidthSm': {
      maxWidth: '800px'
    },
    '.MuiButton-contained.Mui-disabled': {
      backgroundColor: `${palette.grey} !important`
    },
    'label + .MuiInput-formControl': {
      marginTop: 0
    },
    '.MuiFormHelperText-root': {
      margin: '-21px 0',
      marginTop: '3px'
    }
  }
})

export default withStyles(styles)(Promocode)
